import { useLayoutEffect, useState } from 'react';

export default function useFetchHTMLContent(
  url: string,
  subject: string,
  page: string
) {
  const [htmlFileString, setHtmlFileString] = useState<string>();

  const fetchHtml = async (newURL: string) => {
    try {
      const response = await fetch(newURL);
      if (response.ok) {
        const htmlToStringFile = await response.text();
        setHtmlFileString(htmlToStringFile);
      } else {
        console.error('Erro ao buscar o arquivo HTML');
      }
    } catch (error) {
      console.error('Erro ao buscar o arquivo HTML');
    }
  };

  useLayoutEffect(() => {
    fetchHtml(url);
  }, [url, page, subject]);

  return htmlFileString;
}
